export default process.env.NODE_ENV !== 'development' &&
process.env.NODE_ENV !== 'production'
  ? {}
  : ((r) =>
      r.keys().reduce<Record<string, any>>((a, name) => {
        a[name.replace(/^\.\//, '')] = (r(name) as any).default
        return a
      }, {}))(require.context('./variants', false, /.*?\.ts$/))
